/** State of a type without a build state entry, as `getAttachmentBuildState` on the server. */
const NOT_STARTED_BUILD_STATE = 'NOT_STARTED';

/**
 * Build state of an attachment type in a reloaded operation block, for the poll of ButtonWait.
 * @param {Object|null} block block with `attachmentBuildStates`; null when the reload failed
 * @param {string} attachmentType
 * @returns {string|null} the state, NOT_STARTED without an entry, null without a block (ButtonWait
 *   then keeps polling until its timeout)
 */
export const buildStateOfType = (block, attachmentType) => {
  if (!block) {
    return null;
  }
  const entry = block.attachmentBuildStates.find(
    (buildState) => buildState.attachmentType === attachmentType
  );
  return entry ? entry.state : NOT_STARTED_BUILD_STATE;
};
